module.exports = __webpack_public_path__ + "static/media/holstee-manifesto-full.fb63dd81.png";